import React, { FC } from 'react';
import cn from 'classnames';
import styles from './Checkbox.module.scss';

interface ICheckboxProps {
  name: string;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const Checkbox: FC<ICheckboxProps> = (props) => (
  <>
    <label className={cn(styles.container, props.className)}>
      <input
        id={props.name}
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span className={styles.checkmark}></span>
    </label>
    {!!props.label && <div className={styles.label}>{props.label}</div>}
  </>
);
